// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftPropertyType_decode($$enum) {
  if ($$enum === "FOR_SALE" || $$enum === "RENTAL") {
    return $$enum;
  }
}

let localDraftPropertyType_fromString = localDraftPropertyType_decode;

let Utils = {
  localDraftPropertyType_decode: localDraftPropertyType_decode,
  localDraftPropertyType_fromString: localDraftPropertyType_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayKeyFacts_draft",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayKeyFactsStreetAddress_draft"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayKeyFactsDraftType_draft"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayKeyFactsPrice_draft"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayKeyFactsRentalData_draft"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayKeyFactsPropertyType_draft"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalDraftProperty",
          "kind": "LinkedField",
          "name": "draftProperty",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraft",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
